import Controller from "@ember/controller";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { trackedObject } from "@ember/reactive/collections";

export default class ObjectStorageDetailsController extends Controller {
  @service intl;
  @service http;
  @service notification;
  @service router;

  @tracked instance;

  get project() {
    return this.model.project;
  }

  get instanceId() {
    return this.model.instanceId;
  }

  onDescriptionChange = (description) => {
    this.instance.description = description;
  };

  credentialCreated = (credential) => {
    this.instance.credentials.push(credential);
  };

  deleteCredential = task(async (credentialId) => {
    await this.http.request({
      url: `/objectstorage/deletecredential?instanceid=${this.instanceId}&credentialid=${credentialId}`,
      method: "POST",
    });

    this.instance.credentials = this.instance.credentials.filter((credential) => credential.id !== credentialId);

    this.notification.add(
      "success",
      this.intl.t("object-storage.notifications.credentials-deleted.title"),
      this.intl.t("object-storage.notifications.credentials-deleted.text"),
    );
  });

  fetchInstance = task(async () => {
    let response = await this.http.request({
      url: `/objectstorage/instancedetails?instanceid=${this.instanceId}`,
    });

    this.instance = trackedObject(response.content.instance);
    this.instance.credentials = trackedObject(this.instance.credentials);
  });

  deleteInstance = task(async () => {
    await this.http.request({
      url: `/objectstorage/deleteinstance?instanceid=${this.instance.id}`,
      method: "POST",
    });

    this.notification.add(
      "success",
      this.intl.t("object-storage.notifications.instance-deleted.title"),
      this.intl.t("object-storage.notifications.instance-deleted.text"),
    );

    this.router.transitionTo("object-storage.overview");
  });
}
